export default __webpack_public_path__ + "static/media/map6.39e11899.png";